import { render } from "./ShopHeader.vue?vue&type=template&id=688d6b13&scoped=true"
import script from "./ShopHeader.vue?vue&type=script&lang=js"
export * from "./ShopHeader.vue?vue&type=script&lang=js"

import "./ShopHeader.vue?vue&type=style&index=0&id=688d6b13&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688d6b13"]])

export default __exports__